<div class="raptor-sidebar-container radius-block">
  <div class="sidebar-container" #container [ngClass]="{ 'sidebar-container-opened': !collapsed, 'sidebar-collapsed': collapsed }">
    <div class="raptor-sidebar-mobile-details-link show-for-medium-down text-center" [ngClass]="{ 'details-link-collapsed': collapsed }">
      <a mat-button color="primary" (click)="toggleView()">
        <ng-container *ngIf="collapsed"><mat-icon class="expand_less"></mat-icon></ng-container>
        <ng-container *ngIf="!collapsed"><mat-icon class="close"></mat-icon></ng-container>
      </a>
    </div>
    <div *ngFor="let section of sidebar.sections">
      <div [ngSwitch]="section.layout">
        <div *ngSwitchCase="'other'"></div>

        <div *ngSwitchDefault>
          <open-raptor-sidebar-section-default
            [section]="section"
            [form]="form"
            [collapsed]="collapsed">
          </open-raptor-sidebar-section-default>
        </div>
      </div>

    </div>
  </div>
</div>

<div *ngIf="!collapsed" class="show-for-medium-down raptor-sidebar-mobile-overlay-container">
  <div class="raptor-sidebar-mobile-overlay"></div>
</div>
